import React from 'react'
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { verifyStatus } from "../../../actions/userActions";
import { withRouter } from "react-router-dom";
import RejectButtonAdd from "./RejectButtonAdd";
import axios from "axios";
import $ from 'jquery';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Modal, Button } from "react-bootstrap";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { baseUrl } from "../../pages/baseUrl"
class VerifyDocument3 extends React.Component {

    constructor(props) {
        super(props);
        const { user } = this.props.auth;
        this.state = {
            records: [],
            selfistatus: props.record.selfistatus,
            selfiImg: props.record.selfiImg,
            type: 23,
            reject: '',
            errors: {},
            id: props.record._id,
            reject: props.record.selfirejectResion,
            records: props.record,
       
        };

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.record) {
            this.setState({
                id: nextProps.record._id,
                selfistatus: nextProps.record.selfistatus,
                selfiImg: nextProps.record.selfiImg,
                reject: nextProps.record.selfirejectResion,
                records: nextProps.record,
             
            });
        }
        if (nextProps.errors) {
            this.setState({
                errors: nextProps.errors
            });
        }
        if (nextProps.userrecords) {
            this.setState({
                tstatus: nextProps.userrecords.status
            });
        }

        // if (nextProps.auth !== undefined
        //     && nextProps.auth.user !== undefined
        //     && nextProps.auth.user.data !== undefined
        //     && nextProps.auth.user.data.message4 !== undefined
        //     && nextProps.auth.user.data.success) {

        //     toast(nextProps.auth.user.data.message4, {
        //         position: toast.POSITION.TOP_CENTER
        //     });
        // }
    }
    getNodesToRemoveFromElement = (stringContent) => {

        var div = document.createElement("div");
        div.innerHTML = stringContent;
        var text = div.textContent || div.innerText || "";
        return text;
    };

    onChange = e => {
        if (e.target.id === 'reject') {
            this.setState({ reject: e.target.value });
        }
    };
    handleCommentChange = (event, editor) => {

        var data = editor.getData();
        if (data) {
            this.setState({ description: data });
        }
        this.setState({
            showResults: this.state.name === null ? false : true
        })
    };
    getData() {
        const { user } = this.props.auth;
        axios
            .post(baseUrl + "/api/v1/getuserbyid", { id: this.props.match.params.id })
            .then(res => {
                this.setState({
                   
                    d2:  res.data.user.selfirejectReason,
                 
                }, () => {
                    this.setState({ isKycModalOpen: true })
                });
                console.log("res.datares.data", res.data)

            })
            .catch()
    }
    type = () => {
        alert("add");
        this.setState({ catType: "add" });
    };
    onUpdate = e => {
        e.preventDefault();
        const newUser = {
            id: this.props.match.params.id,
            type:"selfi"
        };
        this.props.verifyStatus(newUser);
    };

    closeModel = () => {
        this.setState({ isKycModalOpen: false })
    }

    render() {
        const { errors } = this.state;
        const { user } = this.state;
        return (
            <>

                {this.state.selfistatus &&
                    <>
                        <form noValidate onSubmit={this.onUpdate} id="update-user">
                            <p><b>Selfi :</b> {this.state.selfistatus == "Pending" ? "pending" : (this.state.selfistatus == "Verified" ? "Verified" :
                                <button
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.getData()

                                    }}
                                    // to={
                                    //   "/reject-reason/" + this.props.match.params.id + "/" + 22
                                    // }
                                    type="button"
                                    className="btn btn_man"
                                >
                                    Rejected <i className="fa fa-info-circle"></i>
                                </button>)}</p>
                                {this.state.selfiImg ?<><a href={baseUrl + "/upload/" + this.state.selfiImg} target="_blank"><img src={baseUrl + "/upload/" + this.state.selfiImg} className="img-thumbnail" alt="Cinque Terre"></img></a>
                        
                        <div style={{ display: (this.state.selfistatus !== 'Verified' && this.state.selfistatus !== 'Rejected' ? 'block' : 'none') }}>
                            <button type="submit" className='btn btn-primary'>Verify</button>
                        </div></>:""}
                            
                            
                        </form>
                        { this.state.selfiImg ?

                        <div style={{ display: (this.state.selfistatus !== 'Rejected' && this.state.selfistatus !== 'Verified' ? 'block' : 'none') }}>
                            <RejectButtonAdd record={this.state.records} docStatus={this.state.selfistatus} rejectStatus={this.state.reject} />

                        </div>:""}
                        <hr />
                        <Modal
                            show={this.state.isKycModalOpen}
                            onHide={this.closeKycModal}
                            backdrop="static"
                            keyboard={false}
                        >
                            <Modal.Body>
                                <div className="kyc_popop tc">
                                    <h2 ref={(subtitle) => (subtitle = subtitle)}>
                                        <h3 className="man_hadding">Reject Reason</h3>
                                       
                                            <p className="rejectReason">{this.state.d2}</p>
                                        
                                      
                                    </h2>
                                    <div>
                                        <button className="w100px" onClick={this.closeModel}>
                                            Okay!
                                        </button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </>
                }
            </>
        )
    }
}

VerifyDocument3.propTypes = {
    verifyStatus: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(
    mapStateToProps,
    { verifyStatus }
)(withRouter(VerifyDocument3));
